// Module
var code = `<div class="alert-selector" style="{{>visibility}}">
    <terceraLabel visible="{{visible}}" text="{{label}}" />

    <div class="alert-selector-right">
        <div class="js-button-info{{#if !visibleInfoBtn}} hidden{{/if}}"
             {{^.enabled}}disabled="" {{/}}
             as-tooltip="infoBtnTooltip">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#infotool"></use>
            </svg>
        </div>

        <terceraButton text="{{.buttonText}}"
                       terceraButtonStyle="js-button-gray25"
                       tooltip="{{.btnTooltip}}"
                       on-componentClick="showOrderEntryEvent"
                       visible="{{visible}}"
                       checked="{{isOEOpened}}" />
    </div>
</div>`;
// Exports
export default code;